import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getQuoteByDate } from "../api/getQuotes";

class QuoteContainer extends React.Component {
  componentDidMount() {
    const { date } = this.props;
    this.props.request(date);
  }

  //   componentDidUpdate(prevProps) {
  //     if (this.props.days !== prevProps.days) {
  //       this.props.request(this.props.days);
  //     }
  //   }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const quote = (data && data.data && data.data.quote) || [];
    return render({ quote, loading, failure });
  };
}

QuoteContainer.propTypes = {};

QuoteContainer.defaultProps = {};

export default CreateContainer(getQuoteByDate, QuoteContainer);
